import baseApi from '@/repositories/base_api';
import { IFood } from '@/interfaces/food/food';
import { IAPIResponse } from '@/interfaces/api/response';

export const edamamApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        searchFoods: build.query<IFood[], {query: string, loadMore?: boolean}>({
            query: ({query, loadMore = false}) => ({ url: `/nutrition/search?query=${query}${loadMore ? "&loadMore=true" : ""}`, method: 'get'}),
            transformResponse: (response: IAPIResponse<IFood[]>) => response.data,
            serializeQueryArgs: ({ queryArgs }) => queryArgs.query,
            forceRefetch: ({ currentArg, previousArg }) =>  currentArg?.query !== previousArg?.query,
            merge: (cache, newItems) => {
                const combined = [...cache, ...newItems];
                const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
                cache.length = 0;
                cache.push(...unique);
            },
        }),
    }),
})

export const { 
    useLazySearchFoodsQuery,
} = edamamApi;

